// Dependencies
import styled from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 24px 24px;
  background-color: #eceeee;

  ${MediaQueries.medium} {
    padding: 96px 40px 40px;
  }

  ${MediaQueries.amedium} {
    padding-top: 0;
    position: relative;
    top: -126px;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
  max-width: 1224px;
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Title = styled.h4`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 40px;
  color: #000000;
`

export const Description = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  color: #666b7b;
`

export const CarouselContent = styled.div`
  width: 100%;

  .swiper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    ${MediaQueries.notebook} {
      align-items: flex-end;
    }
  }
`

export const AboutCarouselItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 232px;
  padding: 20px;
  gap: 16px;
  border-radius: 16px;
  background-color: #fff;
`

export const AboutCarouselItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

export const AboutCarouselItemTitleIndex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 600;
  background-color: #df1d3d;
  border-radius: 100px;
  width: 40px;
  height: 40px;
  color: #fff;
  flex-shrink: 0;
`

export const AboutCarouselItemTitleLabel = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #3a3e47;
`

export const AboutCarouselItemDescription = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #666b7b;
`

export const CarouselIconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const CarouselLeftIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background-color: #fff;
  border-radius: 16px 0 0 16px;
  user-select: none;
  cursor: pointer;
`

export const CarouselRightIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  background-color: #fff;
  border-radius: 0 16px 16px 0;
  cursor: pointer;
`
